import * as Yup from "yup";

export const faultRuleSchema = Yup.object().shape({
  code: Yup.string().required("Required"),
  name: Yup.string(),
  description: Yup.string(),
  priority_status: Yup.string(),
});
